/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function ($) {
  // fetch('/discount/SHOTSURPRISE'); // autoapply coupon code 

  if ($('.benefit-images-slider').length > 0 && $('.benefit-images-slider .custom-image-column').length > 3) {

    $('.benefit-images-slider').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      groupCells: 3
    });

  }

  $('button[aria-controls="description-main--nutrition-facts"]').on('click', function () {
    if (!$(this).siblings('#description-main--nutrition-facts').hasClass('slidered')) {
      $(this).siblings('#description-main--nutrition-facts').addClass('slidered')
      setTimeout(function () {
        $('.nutrition-slider').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          prevNextButtons: false
        });
      }, 100)
    }



    // var nutrItemHieght = $(this).siblings('#description-main--nutrition-facts').find('.performance-facts').outerHeight();
    //  console.log(nutrItemHieght)
    // $(this).siblings('#description-main--nutrition-facts').find('.flickity-viewport').css('height',nutrItemHieght + 'px');
  })

  $.fn.multiply = function (numCopies) {
    var newElements = this.clone();
    for (var i = 1; i < numCopies; i++) {
      newElements = newElements.add(this.clone());
    }
    return newElements;
  };

  var bottleItem = $('#bottle-block svg');
  var totalBottles = 0;

  // CHANGE PACK QTY
  $("input[name='packs[pcs]']").on("input", function () {
    $('.cb-progress-bar svg').remove();
    totalBottles = $(this).val();
    bottleItem.multiply(totalBottles).appendTo('.cb-progress-bar');
    changeMaxInputsVal(parseInt(totalBottles));
    $('.pack-total').html(totalBottles);

    $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
      $(qInput).val(0);
      $(qInput).attr('disabled', false);
    });

    $('.active-total').html(0);
    $('.total-price').html(theme.moneyFormat.replace('{{amount}}', '0.00'));
    $('.cb-js-wizard-item').removeClass('item-selected');
  });

  function initBuildForm() {

    // handle edit
    let activePackSize = 21;
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('build_pack_hash') !== null) {
      const pack_hash = urlParams.get('build_pack_hash');
      const cart_json = JSON.parse(document.getElementById('cb-bp-cart').innerHTML);

      for (let i = 0; i < cart_json.items.length; i++) {
        let curr_hash = cart_json.items[i].properties['__item_hash'];

        if (curr_hash === pack_hash) {
          activePackSize = cart_json.items[i].properties['__pack_size'];
        }
      }
    }

    if ($('[name="method[buy]"]:checked').val() === 'one-time') {
      $("#otp-pack-shots-" + activePackSize).prop("checked", true);
    } else {
      $("#ss-pack-shots-" + activePackSize).prop("checked", true);
      $("#bp-subs-bi-weekly").prop("checked", true);
    }

    changeMaxInputsVal(activePackSize);
    $('.cb-progress-bar svg').remove();
    bottleItem.multiply(activePackSize).appendTo('.cb-progress-bar');
    $('.pack-total').html(activePackSize);

    $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
      $(qInput).attr('disabled', false);
    });

    $('.active-total').html(0);
    $('.total-price').html(theme.moneyFormat.replace('{{amount}}', '0.00'));
    $('.cb-js-wizard-item').removeClass('item-selected');
  }

  function changeMaxInputsVal(max_val) {
    $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
      $(qInput).attr('max', parseInt($(qInput).val()) + max_val);
    });
  }

  function updateActiveBottles(count) {
    $('.cb-progress-bar svg').each(function (idx, el) {
      if (idx < count) {
        if (!el.classList.contains('bottle-added')) {
          el.classList.add('bottle-added');
        }
      } else {
        if (el.classList.contains('bottle-added')) {
          el.classList.remove('bottle-added');
        }
      }
    });
  }

  if ($('.wizard-page').length) {
    // MAIN TABS
    $('.tabs-container').find('.tab-button').on('click', function () {
      var tabID = $(this).find('input').attr('id');
      if ($(this).find('input').is(':checked')) {
        $(this).parents('.wizard-page').find('.wizard-tab').each(function () {
          var tabData = $(this).data('tab');
          if (tabID == tabData) {
            $(this).fadeIn();
            initBuildForm();
          } else {
            $(this).hide();
            initBuildForm();
          }

          $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
            $(qInput).val(0);
          });
        });
      }
    });

    initBuildForm();

    // COUNTING

    $('[data-quantity-selector-bp] input').change(function () {

      if (parseInt(this.value) > parseInt(this.max)) {
        this.value = this.max;
      }

      if (this.value > 0) {
        $(this).parents('.cb-js-wizard-item').addClass('item-selected');
      } else {
        $(this).parents('.cb-js-wizard-item').removeClass('item-selected');
      }

      let max_count = parseInt($('[name="packs[pcs]"]:checked').val());
      let count = 0;
      let totalPrice = 0;

      $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
        let currQty = parseInt($(qInput).val());
        count += currQty;
        if (currQty > 0) {
          if ($('[name="method[buy]"]:checked').val() === 'one-time') {
            totalPrice += (parseInt($(qInput).data('bpi-price')) * currQty);
          } else {
            if ($('[name="frequency[frequency]"]:checked').val() === 'bi-weekly') {
              totalPrice += (parseInt($(qInput).data('bpi-biweekly-price')) * currQty);
            } else {
              totalPrice += (parseInt($(qInput).data('bpi-monthly-price')) * currQty);
            }
          }

        }
      });

      $('.active-total').html(count);
      $('.total-price').html(theme.moneyFormat.replace('{{amount}}', (totalPrice / 100).toFixed(2)));
      updateActiveBottles(count);
      changeMaxInputsVal(max_count - count);

      if (count >= max_count) {
        $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
          if (parseInt($(qInput).val()) === 0) {
            $(qInput).attr('disabled', true);
          }
        });

        $('.bar-button button').removeClass('disabled');
      } else {
        $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
          $(qInput).attr('disabled', false);
        });

        $('.bar-button button').addClass('disabled');
      }
    });

    // ATC
    $('.bar-button button').click(function () {
      if (!$(this).hasClass('disabled')) {
        $(this).addClass('disabled');

        const itemHash = (+new Date).toString(36);
        const packSize = parseInt($('[name="packs[pcs]"]:checked').val());

        var groupItems = {
          items: []
        };

        let bpInputs = document.querySelectorAll('[data-quantity-selector-bp] input');

        if ($('[name="method[buy]"]:checked').val() === 'one-time') {

          for (let index = 0; index < bpInputs.length; index++) {
            if (parseInt(bpInputs[index].value) > 0) {
              groupItems.items.push({
                quantity: parseInt(bpInputs[index].value),
                id: bpInputs[index].dataset.bpiVarId,
                properties: { "__item_hash": itemHash, "__pack_size": packSize, "Mix & Match": packSize + 'pack' }
              });
            }
          }

        } else {

          if ($('[name="frequency[frequency]"]:checked').val() === 'bi-weekly') {
            for (let index = 0; index < bpInputs.length; index++) {
              if (parseInt(bpInputs[index].value) > 0) {
                groupItems.items.push({
                  quantity: parseInt(bpInputs[index].value),
                  id: bpInputs[index].dataset.bpiVarId,
                  selling_plan: bpInputs[index].dataset.bpiBiweeklySellingId,
                  properties: { "__item_hash": itemHash, "__pack_size": packSize, "__subscription": 'bi-weekly', "Mix & Match": packSize + 'pack' }
                });
              }
            }
          } else {
            for (let index = 0; index < bpInputs.length; index++) {
              if (parseInt(bpInputs[index].value) > 0) {
                groupItems.items.push({
                  quantity: parseInt(bpInputs[index].value),
                  id: bpInputs[index].dataset.bpiVarId,
                  selling_plan: bpInputs[index].dataset.bpiMonthlySellingId,
                  properties: { "__item_hash": itemHash, "__pack_size": packSize, "__subscription": 'monthly', "Mix & Match": packSize + 'pack' }
                });
              }
            }
          }

        }

        // handle edit mode
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('build_pack_hash') !== null) {
          const pack_hash = urlParams.get('build_pack_hash');
          const cart_json = JSON.parse(document.getElementById('cb-bp-cart').innerHTML);
          let updates = {};

          for (let i = 0; i < cart_json.items.length; i++) {
            let curr_hash = cart_json.items[i].properties['__item_hash'];

            if (curr_hash === pack_hash) {
              updates[cart_json.items[i].key] = 0;
            }
          }

          fetch(`${window.theme.routes.cart}/update.js`, {
            body: JSON.stringify({ updates }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest"
              // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then((response) => {
            if (response.ok) {
              fetch(`${window.theme.routes.cart}/add.js`, {
                body: JSON.stringify(groupItems),
                credentials: "same-origin",
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest"
                  // This is needed as currently there is a bug in Shopify that assumes this header
                }
              }).then((response) => {
                if (response.ok) {
                  window.location.href = window.theme.routes.cart;
                }
              });
            }
          });

        } else {
          fetch(`${window.theme.routes.cart}/add.js`, {
            body: JSON.stringify(groupItems),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest"
              // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then((response) => {
            if (response.ok) {
              window.location.href = window.theme.routes.cart;
            }
          });
        }

      }
    });

    $('.cb-modal-atp').click(function () {
      let modalVarId = $(this).data('bpi-modal-var-id');

      if ($('[name="method[buy]"]:checked').val() === 'one-time') {
        $('.tab-onetime [data-bpi-var-id="' + modalVarId + '"]').val(parseInt($('.tab-onetime [data-bpi-var-id="' + modalVarId + '"]').val()) + 1);
        document.querySelector('.tab-onetime [data-bpi-var-id="' + modalVarId + '"]').dispatchEvent(new Event('change'));
      } else {
        $('.tab-subscription [data-bpi-var-id="' + modalVarId + '"]').val(parseInt($('.tab-subscription [data-bpi-var-id="' + modalVarId + '"]').val()) + 1);
        document.querySelector('.tab-subscription [data-bpi-var-id="' + modalVarId + '"]').dispatchEvent(new Event('change'));
      }
    });

    // EDIT Build pack
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('build_pack_hash') !== null) {
      const pack_hash = urlParams.get('build_pack_hash');
      const cart_json = JSON.parse(document.getElementById('cb-bp-cart').innerHTML);
      let activeTab = '';
      let activePackSize = 21;
      let has_hash = false;

      for (let i = 0; i < cart_json.items.length; i++) {
        let curr_hash = cart_json.items[i].properties['__item_hash'];

        if (curr_hash === pack_hash) {
          activeTab = cart_json.items[i].properties['__subscription'];
          activePackSize = cart_json.items[i].properties['__pack_size'];
          has_hash = true;
        }
      }

      if (has_hash) {
        // activate tab
        if (activeTab === 'monthly' || activeTab === 'bi-weekly') {
          var tabEl = $('#tab-button-subscription');
          var tabID = $(tabEl).find('input').attr('id');
          $(tabEl).find('input').attr('checked', true);
          if ($(tabEl).find('input').is(':checked')) {
            $(tabEl).parents('.wizard-page').find('.wizard-tab').each(function () {
              var tabData = $(this).data('tab');
              if (tabID == tabData) {
                $(this).fadeIn();
                initBuildForm();
              } else {
                $(this).hide();
                initBuildForm();
              }

              $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
                $(qInput).val(0);
              });
            });
          }

          if (activeTab === 'monthly') {
            $("#bp-subs-monthly").prop("checked", true);
          } else {
            $("#bp-subs-bi-weekly").prop("checked", true);
          }
        }

        // activate quantities
        for (let i = 0; i < cart_json.items.length; i++) {
          let curr_hash = cart_json.items[i].properties['__item_hash'];

          if (curr_hash === pack_hash) {
            if (activeTab === '') {
              $('.tab-onetime [data-quantity-selector-bp] input[data-bpi-var-id="' + cart_json.items[i].variant_id + '"]').val(cart_json.items[i].quantity);
              $('.tab-onetime [data-quantity-selector-bp] input[data-bpi-var-id="' + cart_json.items[i].variant_id + '"]').trigger('change');
            } else if (activeTab === 'bi-weekly' || activeTab === 'monthly') {
              $('.tab-subscription [data-quantity-selector-bp] input[data-bpi-var-id="' + cart_json.items[i].variant_id + '"]').val(cart_json.items[i].quantity);
              $('.tab-subscription [data-quantity-selector-bp] input[data-bpi-var-id="' + cart_json.items[i].variant_id + '"]').trigger('change');
            }
          }
        }

        // btn update
        $('.bar-button button').html('Update');
      } else {
        window.location.href = window.location.href.replace(window.location.search, '');
      }

    }

    if (urlParams.get('type') !== null) {
      const wizard_type = urlParams.get('type');

      if (wizard_type === 'subscription') {
        var tabEl = $('#tab-button-subscription');
        var tabID = $(tabEl).find('input').attr('id');
        $(tabEl).find('input').attr('checked', true);
        if ($(tabEl).find('input').is(':checked')) {
          $(tabEl).parents('.wizard-page').find('.wizard-tab').each(function () {
            var tabData = $(this).data('tab');
            if (tabID == tabData) {
              $(this).fadeIn();
              initBuildForm();
            } else {
              $(this).hide();
              initBuildForm();
            }

            $('[data-quantity-selector-bp] input').each(function (idx, qInput) {
              $(qInput).val(0);
            });
          });
        }
      }

    }

  }

  // REMOVE Build pack from cart
  $('.cb-bp-cart-remove').click(function (e) {
    e.preventDefault();
    const pack_hash = $(this).data('build_pack_hash');
    const cart_json = JSON.parse(document.getElementById('cb-bp-cart').innerHTML);
    let updates = {};

    for (let i = 0; i < cart_json.items.length; i++) {
      let curr_hash = cart_json.items[i].properties['__item_hash'];

      if (curr_hash === pack_hash) {
        updates[cart_json.items[i].key] = 0;
      }
    }

    fetch(`${window.theme.routes.cart}/update.js`, {
      body: JSON.stringify({ updates }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
        // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then((response) => {
      if (response.ok) {
        window.location.href = window.theme.routes.cart;
      }
    });
  });

  // cart delivery date
  if ($('[name="attributes[delivery_date]"]:checked').length > 0) {
    fetch(`${window.theme.routes.cart}/update.js`, {
      body: JSON.stringify({
        attributes: { 'delivery_date': $('[name="attributes[delivery_date]"]:checked').val() }
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
        // This is needed as currently there is a bug in Shopify that assumes this header
      }
    });
  }
  $('[name="attributes[delivery_date]"]').change(function () {
    fetch(`${window.theme.routes.cart}/update.js`, {
      body: JSON.stringify({
        attributes: { 'delivery_date': $('[name="attributes[delivery_date]"]:checked').val() }
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
        // This is needed as currently there is a bug in Shopify that assumes this header
      }
    });
  });

  if ($('[name="attributes[delivery_date]"]:checked').length === 0) {
    if ($('[for="tday"]').length === 1) {
      $('[for="tday"]').click();
    }
  }



  // PDP Subscription block
  if ($('.custom-subscription-container').length > 0) {
    // select first subscription option
    $('.custom-subscription-container .cb-option-item:nth-child(1) label.cb-option-button').click();
  }

})(jQuery);

(function () {


  MicroModal.init();

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // Build pack start
  const selectors$oBp = {
    wrapper: '[data-quantity-selector-bp]',
    increase: '[data-increase-quantity-bp]',
    decrease: '[data-decrease-quantity-bp]',
    input: '[data-quantity-input-bp]'
  };
  let QuantityBp = class QuantityBp {
    initButtons() {
      this.increase.addEventListener('click', (function (e) {
        e.preventDefault();
        if (this.input.disabled !== true) {
          let v = parseInt(this.input.value, 10);
          v = isNaN(v) ? 0 : v;
          v++;
          if (v <= this.input.max) {
            this.input.value = v;
            this.input.dispatchEvent(new Event('change'));
          } else {
            this.input.value = this.input.max;
            this.input.dispatchEvent(new Event('change'));
          }
        }
      }).bind(this));
      this.decrease.addEventListener('click', (function (e) {
        e.preventDefault();
        if (this.input.disabled !== true) {
          let v = parseInt(this.input.value, 10);
          v = isNaN(v) ? 0 : v;
          v--;
          v = Math.max(this.min, v);
          if (v <= this.input.max) {
            this.input.value = v;
            this.input.dispatchEvent(new Event('change'));
          } else {
            this.input.value = this.input.max;
            this.input.dispatchEvent(new Event('change'));
          }
        }
      }).bind(this));
    }
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.increase = this.wrapper.querySelector(selectors$oBp.increase);
      this.decrease = this.wrapper.querySelector(selectors$oBp.decrease);
      this.input = this.wrapper.querySelector(selectors$oBp.input);
      this.min = parseInt(this.input.getAttribute('min'), 10);
      this.initButtons();
    }
  };

  const quantityBpWrappers = document.querySelectorAll(selectors$oBp.wrapper);
  quantityBpWrappers.forEach((qty) => {
    new QuantityBp(qty);
  });


  // Build pack end

})();


// ECOM CUSTOM

// DESCRIPTION ACCORDION
const faqs = document.querySelectorAll(".faq-item");

faqs.forEach((faq) => {
  const question = faq.querySelector(".faq-question");
  const answer = faq.querySelector(".faq-answer");

  question.addEventListener("click", () => {
    // Close other open FAQs
    faqs.forEach((item) => {
      if (item !== faq) {
        item.classList.remove("active");
        item.querySelector(".faq-answer").style.maxHeight = null;
      }
    });

    // Toggle current FAQ
    faq.classList.toggle("active");

    if (faq.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = null;
    }
  });
});

// VIDEO SECTION

const videoBlockSwiper = new Swiper(".video__swiper", {
  slidesPerView: "auto",
  spaceBetween: 15.2,
  speed: 600,
  loop: true,
  pagination: {
    el: ".video_pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".video_block_next",
    prevEl: ".video_block_prev",
  },
});

const videoContainers = document.querySelectorAll('.video_block_item');

videoContainers.forEach(container => {
  const video = container.querySelector('video');
  const playButton = container.querySelector('.custom-play-button');

  if (!video || !playButton) return;

  playButton.addEventListener('click', function () {
    video.controls = true; // show controls immediately
    video.play().then(() => {
      // success
      console.log("VIDEO PLAYED");
      container.classList.add('playing');
      playButton.style.display = 'none'; // hide button
      video.muted = false; // unmute after starting
    }).catch(err => {
      console.error("Video play failed:", err);
    });
  });

  // Pause on video click
  video.addEventListener('click', function () {
    if (!video.paused) {
      video.pause();
      container.classList.remove('playing');
      video.controls = false;
      playButton.style.display = 'flex'; // show button again
    }
  });

  // Reset on end
  video.addEventListener('ended', function () {
    container.classList.remove('playing');
    video.controls = false;
    playButton.style.display = 'flex'; // show again
    video.currentTime = 0;
  });
});


// Thumbnails swiper
const thumbsSwiper = new Swiper(".product-thumbs-swiper", {
  direction: 'vertical',
  spaceBetween: 20,
  slidesPerView: 'auto',
  speed: 600,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  breakpoints: {
    0: {
      direction: 'horizontal',
      slidesPerView: 5,
      spaceBetween: 10,
    },
    1201: {
      direction: 'horizontal',
      slidesPerView: 5,
    },
    1401: {
      direction: 'vertical',
    }
  }
});

// Main product media swiper
const mainSwiper = new Swiper(".product-media-swiper", {
  spaceBetween: 10,
  loop: true,
  speed: 600,
  navigation: {
    nextEl: ".product_main_next",
    prevEl: ".product_main_prev",
  },
  thumbs: {
    swiper: thumbsSwiper,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.15
    },
    425: {
      slidesPerView: 'auto'
    }
  }
});

// WAVY REVIEW SECTION SWIPER

const ReviewSwiper = new Swiper(".review__swiper", {
  slidesPerView: "auto",
  spaceBetween: 40,
  effect: "coverflow",
  speed: 600,
  coverflowEffect: {
    rotate: 0,
    stretch: 80,
    depth: 0,
    modifier: 0,
    slideShadows: true,
  },
  on: {
    click(event) {
      ReviewSwiper.slideTo(this.clickedIndex);
    }
  },
  pagination: {
    el: ".review__pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".review__next",
    prevEl: ".review__prev",
  },
  breakpoints: {
    320: {
      coverflowEffect: {
        rotate: 0,
        stretch: -2,
        depth: 120,
        modifier: 1,
        slideShadows: false,
      },
      loop: true,
      centeredSlides: true,
    },
    991: {
      coverflowEffect: {
        rotate: 0,
        stretch: -2,
        depth: 120,
        modifier: 1,
        slideShadows: false,
      },
      centeredSlides: true,
    },
    1448: {
      coverflowEffect: {
        rotate: 0,
        stretch: 80,
        depth: 0,
        modifier: 0,
        slideShadows: false,
      },
      centeredSlides: false,
      loop: true
    },
  },
});

// FAQS SECTION V2

const faqAccordionHeaders = document.querySelectorAll(`[data-accordion-header]`);

faqAccordionHeaders.forEach(accordionHeader => {
  accordionHeader.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const accordionBody = accordionHeader.nextElementSibling;
    const isCurrentlyActive = accordionHeader.classList.contains('active');

    // Close all accordions first
    faqAccordionHeaders.forEach(header => {
      header.classList.remove('active');
      const body = header.nextElementSibling;
      body.style.maxHeight = '0px';
    });

    // If the clicked accordion wasn't active, open it
    if (!isCurrentlyActive) {
      accordionHeader.classList.add('active');
      accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';
    }
  });
});

// CT OPTION

// VIDEO LAZY

// END ECOM CUSTOM
